<template>
  <section class="itinerary-staff-pick-event">
    <AppRouteLink :class="{ 'itinerary-staff-pick-event__link': routeTo }" :route-to="routeTo">
      <header>
        <img
          v-if="mediaUrl"
          class="itinerary-staff-pick-event__image"
          loading="lazy"
          :src="mediaUrl"
          :alt="event.title"
        />
        <div v-else class="itinerary-staff-pick-event__image no-image" />
        <h3 class="itinerary-staff-pick-event__title">{{ event.title }}</h3>
      </header>
    </AppRouteLink>
    <p v-if="event.address" class="itinerary-staff-pick-event__address">{{ event.address }}</p>
    <p v-if="dates" class="itinerary-staff-pick-event__dates">{{ dates }}</p>
  </section>
</template>

<script>
import { getEntityRoute } from '@/helpers/entityType';
import ImageHandler from '@/helpers/ImageHandler';

import AppRouteLink from '@/components/partials/AppRouteLink.vue';
import { formatDate } from '@/helpers/dateTimeHelper';

export default {
  components: { AppRouteLink },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mediaUrl() {
      return new ImageHandler().getFirstImgFromMedia(this.event);
    },
    routeTo() {
      return this.event.isPublished ? getEntityRoute({ ...this.event, __typename: this.event.graphqlType }) : null;
    },
    dates() {
      if (!this.event.earliestStartDate) {
        return null;
      }

      const startDate = formatDate(this.event.earliestStartDate);
      const endDate = formatDate(this.event.latestEndDate);

      return endDate !== startDate ? `${startDate} - ${endDate}` : startDate;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-staff-pick-event {
  &__link {
    color: inherit;
  }
  &__link:hover &__title {
    opacity: 0.7;
  }

  &__image {
    width: 100%;
    height: 180px;
    object-fit: cover;

    &.no-image {
      background-color: vars.$c-gray-d8;
    }
  }

  &__title {
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  &__address {
    margin-top: 8px;
    margin-bottom: 0;
    color: vars.$c-dark-5b;
    text-align: justify;
    font-size: 14px;
    line-height: 21px;
    text-transform: uppercase;
  }

  &__dates {
    margin-top: 8px;
    margin-bottom: 0;
    color: vars.$c-gray-a2;
    font-size: 14px;
  }
}
</style>
